import { personalNameApi } from '@/api'
import {PersonalName} from '@/models'

export default {
  namespaced: true,

  state: {
    personalName: new PersonalName()
  },

  getters: {},

  mutations: {
    setPersonalName(state, payload) {
      state.personalName = payload
    },

    clearState(state) {
      state.personalName = new PersonalName()
    },
  },

  actions: {
    async GET_PERSONAL_NAME({ commit, dispatch }, payload) {
      try {
        const data = await personalNameApi.findAllByPersonalData({id: payload.id})
        if (data.id) {
          commit('setPersonalName', data)
        }
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async CREATE_PERSONAL_NAME({ commit }, payload) {
      try {
        const data = await personalNameApi.create(payload)
        if (data.id) {
          commit('setPersonalName', data)
        }
        return data
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    },

    async UPDATE_PERSONAL_NAME({ commit }, payload) {
      try {
        commit('setPersonalName', payload)
        return await personalNameApi.update(payload)
      } catch (e) {
        console.log(e)
        return Promise.reject(e)
      }
    }
  }
}
